

























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import { MapStore } from '@/store/map';
import { Flicking } from '@egjs/vue-flicking';
import { Pagination } from '@egjs/flicking-plugins';
import '@egjs/flicking-plugins/dist/pagination.css';
import CustomMetricsTagChart from '@/components/charts/CustomMetricsTagChart.vue';
import ApiService from '@/services/api.service';
import TargomoService from '@/services/targomo.service';
import camelcaseKeys from 'camelcase-keys';
import jsPDF from 'jspdf';
import { carouselImages } from '@/consts';

@Component({
  components: { Flicking, CustomMetricsTagChart }
})
export default class WidgetAllStatisticModal extends Vue {
  @Prop({ required: true }) readonly isMobileDevice: boolean;

  prev() {
    this.$el.querySelector('.flicking-viewport').__vue__.prev();
  }

  next() {
    this.$el.querySelector('.flicking-viewport').__vue__.next();
  }

  mapStore = getModule(MapStore, this.$store);

  plugins = [new Pagination({ type: 'bullet' })];
  offers: Record<string, string> = {};
  occupancyRate: Record<string, string>[] = [];
  touristFlow: { labels: string[]; values: string[] } = null;
  potentialDemand: Record<string, number> = {};
  carouselImages = carouselImages;
  mapImage: any = '';
  isGeneratingPdf = false;

  @Watch('mapStore.lastMarkerCoord', { immediate: true, deep: true })
  onLastCoordinateChanged() {
    ApiService.getAirDna().then(response => {
      this.occupancyRate = response.map(({ properties }: any) => ({
        name: properties.epci_name,
        occupancyRate: properties.Taux_occupation,
        offerAvailable: properties.Offre_disponible,
        income: properties.Revenu
      }));
    });
    ApiService.getFluxVision().then(response => {
      if (response.length > 1) {
        const entries: any = response.map(({ properties }: any) => [properties.nom, properties.flow_by_region_Total]);
        entries.sort(([, value1], [, value2]) => +value1 - +value2);

        this.touristFlow = {
          labels: entries.map(([key]) => key),
          values: entries.map(([, value]) => value)
        };
      } else {
        if (response.length > 0) {
          const touristFlowObject: { labels: string[]; values: string[] } = { labels: [], values: [] };
          const properties = response[0].properties;
          const tempArray = [];

          for (const key in properties) {
            if (key.startsWith('flow_by_region_') && !key.includes('field') && key !== 'flow_by_region_Total') {
              const label = key.replace('flow_by_region_', '').replace(/_/g, ' ');
              const value = properties[key];
              tempArray.push({ label, value });
            }
          }

          tempArray.sort((a, b) => a.value - b.value);

          touristFlowObject.labels = tempArray.map(item => item.label);
          touristFlowObject.values = tempArray.map(item => item.value);

          if (properties.nom) {
            touristFlowObject.labels.push(properties.nom);
          }
          if (properties.flow_by_region_Total) {
            touristFlowObject.values.push(properties.flow_by_region_Total);
          }

          this.touristFlow = touristFlowObject;
        }
      }
    });
  }
  @Watch('mapStore.filterPolygon', { immediate: true, deep: true })
  onFilterPolygonChanged() {
    ApiService.getObjectCounts().then(response => {
      this.offers = camelcaseKeys(response, { deep: true });
    });
    TargomoService.getPotentialDemand().then((response: any) => {
      this.potentialDemand = response;
    });
  }

  getCadastralInfoLink() {
    const [lng, lat] = this.mapStore.lastMarkerCoord;
    const link =
      'https://www.geoportail-urbanisme.gouv.fr/map/#tile=1&lon=5.146990063602278&lat=48.71406322248146&zoom=8.431165306661331';
    if (!lng || !lat) {
      return `${link}&mlon=5.322098&mlat=49.006559`;
    }
    return `${link}&mlon=${lng}&mlat=${lat}`;
  }

  takeScreenshot(map: any) {
    return new Promise(resolve => {
      map.once('render', () => {
        resolve(map.getCanvas().toDataURL());
      });
      map.setBearing(map.getBearing());
    });
  }

  generatePdf() {
    this.takeScreenshot(this.mapStore.map).then(data => {
      this.mapImage = data;
      const element: any = this.$refs.screenshotTarget;
      element.style.overflow = 'visible';
      this.mapStore.setLoading(true);

      const doc = new jsPDF('p', 'px', [540, element.scrollHeight + 500]);

      this.isGeneratingPdf = true;
      doc.html(element, {
        callback: doc => {
          doc.save('laMeuse.pdf');
          element.style.overflow = 'auto';
          this.mapStore.setLoading(false);
          this.isGeneratingPdf = false;
          this.mapImage = '';
        }
      });
    });
  }

  getNames(value: string) {
    const names: any = {
      countActivities: 'Activités',
      countEntertainmentPlaces: 'Lieux de divertissement',
      countGites: 'Gîtes',
      countGuestRooms: "Chambres d'hôtes",
      countHotels: 'Hôtels',
      countRestaurants: 'Restaurants',
      countShops: 'Commerces',
      countSupermarkets: 'Supermarchés'
    };
    return names[value];
  }

  mainContainerStyle() {
    return {
      width: this.isMobileDevice ? 'calc(100vw - 60px)' : '500px',
      right: this.isMobileDevice ? '10px' : '0',
      margin: this.isMobileDevice ? '0 auto' : 0,
      bottom: this.isMobileDevice ? `calc(100vh * 0.2 + ${this.mapStore.noiseLevelLegend ? '40' : '10'}px)` : 'auto',
      top: this.isMobileDevice ? 'auto' : '0'
    };
  }
}
